<template>
  <div>
    <ExpertStatisticsTemplate
      :periodSelector="periodSelector"
      @timeSelector="selectedtime = $event"
      :elements="extensions"
      :clearTimeSelector="clearTimeSelector"
      @selector="
        $emit('update:selector', $event),
          $emit('setSelector', $event),
          $store.dispatch('pbxPeriodSelected', $event)
      "
      @setPeriod="(...args) => setPeriod(...args)"
      :filters="filters"
      @activeBanner="$emit('activeBanner')"
      @successMsg="$emit('successMsg', $event)"
      @success="$emit('success', $event)"
    >
      <template v-slot:selector>
        <!-- <PbxDashboardSelector
          v-if="callerNumbers"
          @selector="period = $event"
          @button-selector="(...args) => getSelectedButton(...args)"
          @action="
            $emit('action', $event),
              (selectedElement = $event),
              getCallerNumber($event)
          "
          :selectHostname="selectHostname"
          :didNumbers="callerNumbers"
          @selectTop="showTop = $event"
          :selectedTop="showTop"
          :buttonSelected="this.buttonSelected"
          :elements="null"
        /> -->
      </template>
      <template v-slot:filters>
        <!-- Active Filters Badges -->
        <!-- <div
          v-if="activeFilters.length"
          class="mt-8 -mb-6 flex flex-wrap gap-3"
        >
          <div
            v-for="item in activeFilters"
            :key="item.key"
            class="flex items-center bg-teal-100 text-teal-800 px-2 py-1 rounded-lg shadow-sm border border-teal-300 text-xs"
          >
            <span class="font-medium">{{ item.label }}:</span>
            <span class="ml-1">{{ item.value }}</span>

            <button
              @click="removeFilter(item.key)"
              class="ml-2 text-teal-700 hover:text-teal-900 hover:bg-teal-200 rounded-full p-1 transition"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-3 w-3"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div> -->
        <CallFlowAnalyserFilters
          v-if="initialized"
          @apply-filters="applyFilters"
          @reset-filters="resetFilters"
          @clearForm="clearAll"
          @selectAll="selectAll"
          @clearDestinationDns="
            (selectedDestinationDns = []), (filters.destination_dn = '')
          "
          @clearOriginDns="(selectedOriginDns = []), (filters.origin_dn = '')"
          :elementsData="elementListConcatReduce"
          :extensionsReduced="extensionsReduced"
          :queuesReduced="queuesReduced"
          :didsReduced="didsReduced"
          :callersReduced="callersReduced"
          :selectedPbxElements="selectedPbxElements"
          :addOriginDn="addOriginDn"
          :addDestinationDn="addDestinationDn"
          :addDidNumber="addDidNumber"
          :addCallerNumber="addCallerNumber"
          :filters="filters"
          :selectedOriginDns="selectedOriginDns"
          :selectedDestinationDns="selectedDestinationDns"
          :selectedDidNumbers="selectedDidNumbers"
          :selectedCallerNumbers="selectedCallerNumbers"
          :elementRemovedDestination="elementRemovedDestination"
          :elementRemovedOrigin="elementRemovedOrigin"
          :elementRemovedDid="elementRemovedDid"
        />
      </template>
      <template v-slot:content>
        <PbxHeader
          v-model:search="search"
          pbxMenuType="queueDetail"
          :periodSelector="period"
          :parseDateRange="parseDateRange"
          @select-hostname="selectHostname = $event"
          :selectedQueue="selectedQueue"
        />

        <div v-if="calls && calls.length > 0" class="flex flex-col mx-2">
          <CallFlowAnalyser
            :calls="calls"
            :pagination="pagination"
            :on-page-change="changePage"
            :on-refresh="getCallerNumbers"
          />
        </div>
        <div v-else class="mt-8 overflow-x-auto sm:-mx-6 lg:-mx-0">
          <div
            v-if="!this.selectedElement || this.selectedElement.length <= 0"
            class="text-center max-w-lg mx-auto space-y-4"
          >
            <font-awesome-icon
              icon="search"
              class="mx-auto h-10 w-10 text-teal-600"
              aria-hidden="true"
            />
            <h1 class="text-gray-900 font-bold text-2xl">
              Analyse du cheminement de vos appels.
            </h1>
            <h3 class="mt-2 text-lg font-medium text-gray-900">
              L'<span class="font-bold">analyseur d'appels</span> vous permet de
              <span class="font-bold"
                >vérifier la précision des statistiques</span
              >
              (présentées dans les graphiques et les tableaux) et de
              <span class="font-bold"
                >visualiser le cheminement complet de l'appel</span
              >
              sélectionné. Cet outil vous offre ainsi la possibilité d'<span
                class="font-bold"
                >analyser en détail les événements</span
              >
              qui ont marqué l'interaction.
            </h3>
            <div class="pt-10">
              <PleaseSelectElement
                dataDescription="Veuillez appliquer les filtres"
              />
            </div>
          </div>
          <div
            v-else
            class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-6"
          >
            <div class="overflow-hidden border-b border-gray-200 rounded-md">
              <NoData />
            </div>
          </div>
        </div>
      </template>
    </ExpertStatisticsTemplate>
    <SlidesTutorialCard ref="cdr_tutorial"></SlidesTutorialCard>
  </div>
</template>

<script>
import axios from "axios";
import NoData from "../../components/NoData.vue";
import PleaseSelectElement from "../../components/PleaseSelectElement.vue";
import ExpertStatisticsTemplate from "./ExpertStatisticsTemplate.vue";
import CallFlowAnalyser from "../../components/PBX/CallFlowAnalyser.vue";
import CallFlowAnalyserFilters from "../../components/PBX/CallFlowAnalyserFilters.vue";

import PbxHeader from "../../components/PBX/PbxHeader.vue";
import PbxDashboardSelector from "../../components/PBX/PbxDashboardSelector.vue";
import SlidesTutorialCard from "../../components/PBX/SlidesTutorialCard.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    PbxHeader,
    PbxDashboardSelector,
    CallFlowAnalyser,
    ExpertStatisticsTemplate,
    NoData,
    PleaseSelectElement,
    CallFlowAnalyserFilters,
    SlidesTutorialCard,
  },
  data() {
    return {
      selectedOriginDns: [], // for origin DN selection
      selectedDestinationDns: [], // for destination DN selection
      selectedDidNumbers: [], // for DID number selection
      selectedCallerNumbers: [], // for Caller number selection
      search: "",
      selectedElement: "",
      selectedQueue: "",
      period: "",
      selectHostname: "",
      trtcData: undefined,
      callerNumbers: [],
      calls: [],
      showTop: "top10",
      textMonth: "",
      buttonSelected: "month",
      callerData: [],
      sumarryData: [],
      categories: [],
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0,
        last_page: 1,
      },
      filters: {
        start_date: "",
        end_date: "",
        start_time: "00:00",
        end_time: "23:59",
        origin_dn: "",
        destination_dn: "",
        did_number: "",
        caller_number: "",
        origin_dn_type: "",
        destination_dn_type: "",
        call_way: "",
        call_status: "all",
      },
      selectedItems: [],
      elementGroupsExtensionList: [],
      elementGroupsQueueList: [],
      elementGroupsDIDList: [],
      elementGroupsCallerList: [],

      // Also ensure the final result lists are initialized:
      extensionsReduced: [],
      queuesReduced: [],
      didsReduced: [],
      callersReduced: [],
      elementListConcatReduce: [],

      // And the lists from your original method:
      extensionsList: [],
      queueList: [],
      DIDsList: [],
      elementGroups: [],
      elementGroupsQueues: [],
      elementsDataQueues: {},
      groupName: "",
      selectedPbxElements: [],
      selectedElementsLength: 0,
      selectedPbxElementsCount: {},
      elementGroupMap: {},
      initialized: false,
      selectedtime: [],
    };
  },
  methods: {
    async downloadReport() {
      this.$emit("setLoading", true);

      const params = new URLSearchParams({
        ...this.filters,
        page: this.pagination.current_page,
        per_page: this.pagination.per_page,
      }).toString();

      const url = `${this.$cookie.getCookie("API")}/api/v1.2/${
        this.hostName
      }/cdr-report/export?${params}`;

      try {
        const res = await axios.get(url, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
          responseType: "blob",
        });

        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        // Set the filename
        const reportDate = `${this.filters.start_date}_to_${this.filters.end_date}`;
        link.download = `Queue_Report_${reportDate}.xlsx`;

        // Trigger the download
        link.click();
        window.URL.revokeObjectURL(link.href);
      } catch (error) {
        this.errorHandling(error);
      }

      this.$emit("setLoading", false);
    },
    async getPbxMap() {
      if (this.hostName && this.hostName !== "null") {
        let url = `${localStorage.getItem("apiUrl")}/api/v1.2/${
          this.hostName
        }/map`;
        try {
          const res = await axios.get(url, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("apiToken")}`,
            },
          });
          this.$store.dispatch("pbxMap", res.data);
          localStorage.setItem("pbxMap", JSON.stringify(res.data));
          this.pbxMapData = res.data;

          if (
            !res.data ||
            (res.data && Object.keys(res.data).length == 0) ||
            (res.data && !res.data.active)
          ) {
            this.$router.push("/page-unavailable");
          }

          return res.data;
        } catch (error) {
          this.errorHandling(error);
        }
      }
    },
    async concatArray() {
      // 1. Initialize final results containers
      this.extensionsReduced = []; // Define in data()
      this.queuesReduced = []; // Define in data()
      this.didsReduced = []; // Define in data()
      this.callersReduced = []; // Define in data()
      this.elementListConcatReduce = []; // Define in data()

      // 2. Fetch data
      const objectDataGroups = await this.getElementGroups();
      const objectData = await this.getPbxMap();

      if (!objectDataGroups?.length && !objectData) {
        return; // Exit if no data
      }

      // --- Helper Functions (Defined below) ---

      // 3. Process Element Groups
      const groupedElements = this.processElementGroups(
        objectDataGroups,
        objectData,
      );
      const {
        extensionListConcat,
        queueListConcat,
        DIDListConcat,
        callerListConcat,
      } = groupedElements;

      // 4. Process Ungrouped Elements (PBX Map)
      const ungroupedElements = this.processUngroupedElements(objectData);
      const { extensionsArray, queuesArray, DIDsArray } = ungroupedElements;

      // 5. Prepare and Concatenate "Elements" (Ungrouped) to their respective lists
      extensionListConcat.push(this.createElementsGroup(extensionsArray));
      queueListConcat.push(this.createElementsGroup(queuesArray));
      DIDListConcat.push(this.createElementsGroup(DIDsArray));

      // 6. Reduce and Filter All Three Lists
      this.extensionsReduced = this.reduceAndFilterList(extensionListConcat);
      this.queuesReduced = this.reduceAndFilterList(queueListConcat);
      this.didsReduced = this.reduceAndFilterList(DIDListConcat);
      this.callersReduced = this.reduceAndFilterList(callerListConcat);

      // 7. Create the final combined list (if still needed)
      this.elementListConcatReduce = [
        ...this.extensionsReduced,
        ...this.queuesReduced,
        ...this.didsReduced,
        ...this.callersReduced,
      ];
    },
    processElementGroups(objectDataGroups, objectData) {
      const extensionListConcat = [];
      const queueListConcat = [];
      const DIDListConcat = [];
      const callerListConcat = [];

      const groupTypes = {
        0: {
          list: extensionListConcat,
          map: objectData.extensions,
          type: "extension",
          elementList: this.elementGroupsExtensionList,
        },
        4: {
          list: queueListConcat,
          map: objectData.call_queues,
          type: "queue",
          elementList: this.elementGroupsQueueList,
        },
        1: {
          list: DIDListConcat,
          map: objectData.dids,
          type: "did",
          elementList: this.elementGroupsDIDList,
        },
        99: {
          list: callerListConcat,
          map: null,
          type: "caller",
          elementList: this.elementGroupsCallerList,
        },
      };

      Object.entries(groupTypes).forEach(
        ([type, { list, map, elementList }]) => {
          const filteredGroups = objectDataGroups.filter(
            (res) => res.type == type,
          );

          filteredGroups.forEach((group, indexEl) => {
            const resources = JSON.parse(group.resources || "[]");
            const methods = [];

            // Add a placeholder/group entry to the dedicated group list
            elementList.push({ value: null, label: null, type: type });

            resources.forEach((resourceId) => {
              let label = resourceId;
              if (type === "extension") {
                label = `${resourceId}:${map[resourceId]}`;
              } else if (type === "queue" && map[resourceId]?.name) {
                label = `${resourceId}:${map[resourceId].name}`;
              }

              const [value, namePart] = label.split(":");

              if (value) {
                methods.push({
                  value: value,
                  label: value,
                  group: true,
                  type: type, // Keep type here for safety
                });
              }
            });

            const objDataGroups = { name: group.name, methods: methods };

            // Use a conditional push for simplicity, splice logic was complicated
            if (this.$route.name !== "ExpertStatisticsQueueDetail") {
              list.push(objDataGroups);
            }
          });
        },
      );

      return {
        extensionListConcat,
        queueListConcat,
        DIDListConcat,
        callerListConcat,
      };
    },

    /**
     * Processes all elements from the PBX map that are not in a group.
     * @param {Object} objectData - The PBX map data.
     * @returns {Object} An object containing the three arrays of ungrouped elements.
     */
    processUngroupedElements(objectData) {
      const extensionsArray = [];
      const queuesArray = [];
      const DIDsArray = [];

      // Process DIDs
      Object.values(objectData.dids).forEach((did) => {
        DIDsArray.push({
          value: did,
          label: did,
          type: "did",
          group: false,
        });
        this.DIDsList.push(DIDsArray[DIDsArray.length - 1]); // Assuming DIDsList is a component data property
      });

      // Process Extensions
      Object.keys(objectData.extensions).forEach((ext) => {
        const name = objectData.extensions[ext] || "Empty";
        extensionsArray.push({
          value: ext,
          label: `${ext} - ${name}`,
          type: "extension",
          group: false,
        });
        this.extensionsList.push(extensionsArray[extensionsArray.length - 1]); // Assuming extensionsList is a component data property
      });

      // Process Queues
      Object.keys(objectData.call_queues).forEach((queueId) => {
        const queue = objectData.call_queues[queueId];
        queuesArray.push({
          value: queueId,
          label: `${queueId} - ${queue.name}`,
          type: "queue",
          group: false,
        });
        this.queueList.push(queuesArray[queuesArray.length - 1]); // Assuming queueList is a component data property
      });

      return { extensionsArray, queuesArray, DIDsArray };
    },

    /**
     * Creates the structure for the "Elements" group containing ungrouped items.
     * @param {Array} methodsArray - The array of ungrouped elements (extensions, queues, or DIDs).
     * @returns {Object} The group object ready for concatenation.
     */
    createElementsGroup(methodsArray) {
      return {
        name: "Elements",
        methods: methodsArray,
      };
    },

    /**
     * Applies the common reduction and filtering logic to a list.
     * @param {Array} listConcat - The array containing grouped and ungrouped elements.
     * @returns {Array} The final reduced and filtered list.
     */
    reduceAndFilterList(listConcat) {
      let reducedList = listConcat.reduce((flat, constructor) => {
        return flat
          .concat({
            label: constructor.name,
            value: constructor.methods.map((method) => method.value),
            isConstructor: true,
          })
          .concat(
            constructor.methods.map((method) => ({
              label: method.label,
              value: method.value,
              group: method.group,
            })),
          );
      }, []);

      // Apply the final filtering logic
      reducedList = reducedList.filter((el) => {
        if (this.isNotMultiple) {
          return !el.isConstructor && !el.group;
        } else {
          return el.label !== "Elements" && (!el.group || el.isConstructor);
        }
      });

      return reducedList;
    },
    async getElementGroups() {
      let objectData = undefined;
      if (this.hostName && this.hostName !== "null") {
        try {
          const res = await axios.get(
            `${localStorage.getItem("apiUrl")}/api/v1.2/${
              this.hostName
            }/resource-groups`,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("apiToken")}`,
              },
            },
          );
          objectData = res.data;
          return objectData;
        } catch (error) {
          this.errorHandling(error);
        }
      }
    },
    clearAll() {
      this.selectedPbxElements.length = 0;
      this.$store.dispatch("groupSelected", false);
      this.$store.dispatch("groupSelectedName", []);
    },
    selectAll() {
      this.selectedPbxElements = this.queueList.map(({ value }) => value);
      this.$store.dispatch("groupSelected", false);
      this.$store.dispatch("groupSelectedName", []);
    },
    async changePage(page) {
      this.fetchPreanswerTimes(page);
    },
    addOriginDn(element) {
      this.toggleFilterSelection(element, this.selectedOriginDns, "origin_dn");
    },

    addDestinationDn(element) {
      this.toggleFilterSelection(
        element,
        this.selectedDestinationDns,
        "destination_dn",
      );
    },

    addDidNumber(element) {
      this.toggleFilterSelection(
        element,
        this.selectedDidNumbers,
        "did_number",
      );
    },

    addCallerNumber(element) {
      this.toggleFilterSelection(
        element,
        this.selectedCallerNumbers,
        "caller_number",
      );
    },

    toggleFilterSelection(element, selectedArray, filterKey) {
      const elementValue =
        typeof element.value === "object" ? element.value : [element.value];

      elementValue.forEach((value) => {
        // Normalize the value to a string for consistency with filters
        const normalizedValue = String(value)
          .split(" ")[0]
          .replace(/^\*/, "0")
          .replace(/[^0-9]/g, "");

        const index = selectedArray.indexOf(normalizedValue);

        if (index > -1) {
          // Element is already selected, so remove it
          selectedArray.splice(index, 1);
        } else {
          // Element is not selected, so add it
          selectedArray.push(normalizedValue);
        }
      });
      this.filters[filterKey] = selectedArray.join(",");
    },
    setPeriod(...args) {
      // this.initializeFiltersFromUrl();
      this.filters.start_date = args[0];
      this.filters.end_date = args[1];

      // this.initializeFiltersFromUrl();

      // this.getCallerNumbers();
      if (this.selectedElement) {
        // this.getCallerNumber(this.selectedElement);
      }
    },
    getTitle(obj) {
      return Object.keys(obj)[0];
    },
    calculatePercentage(count, totalCount) {
      const percentage = (parseInt(count) / parseInt(totalCount)) * 100;
      return parseFloat(percentage.toFixed(2));
    },
    getSelectedButton(...args) {
      this.buttonSelected = args[0];
      this.textMonth = args[1];
    },
    getButtonSelectedFromQueryPeriod() {
      let period = undefined;
      if (this.$route.query.period) {
        period = this.$route.query.period;
      }
      if (period) {
        if (period.length == 8) {
          this.buttonSelected = "day";
        } else if (period.length == 6) {
          this.buttonSelected = "month";
        } else {
          this.buttonSelected = "week";
        }
      }
    },
    async getCallerNumbers() {
      this.$emit("setLoading", true);

      const params = new URLSearchParams({
        ...this.filters,
        page: this.pagination.current_page,
        per_page: this.pagination.per_page,
      }).toString();

      const url = `${this.$cookie.getCookie("API")}/api/v1.2/${
        this.hostName
      }/cdr-report?${params}`;

      try {
        const res = await axios.get(url, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        });

        console.log("res ==> ", res.data.data);
        this.calls = res.data.data || [];
        this.pagination = {
          current_page: res.data.current_page,
          per_page: res.data.per_page,
          total: res.data.total,
          last_page: res.data.last_page,
        };
      } catch (error) {
        this.errorHandling(error);
      }

      this.$emit("setLoading", false);
    },

    async changePage(page) {
      this.pagination.current_page = page;
      await this.getCallerNumbers();
    },
    async applyFilters() {
      this.pagination.current_page = 1;
      this.updateUrlParams();
      await this.getCallerNumbers();
    },

    resetFilters() {
      this.selectedOriginDns = [];
      this.selectedDestinationDns = [];
      this.selectedDidNumbers = [];
      this.selectedCallerNumbers = [];

      Object.assign(this.filters, {
        start_time: "00:00",
        end_time: "23:59",
        origin_dn: "",
        destination_dn: "",
        did_number: "",
        caller_number: "",
        origin_dn_type: "",
        destination_dn_type: "",
        call_way: "",
        call_status: "all",
      });

      this.pagination.current_page = 1;
      this.updateUrlParams();
      this.applyFilters();
    },

    updateUrlParams() {
      const params = new URLSearchParams({
        ...this.filters,
        page: this.pagination.current_page,
        per_page: this.pagination.per_page,
      }).toString();
      this.$router.replace({
        query: Object.fromEntries(new URLSearchParams(params)),
      });
    },
    sortArrObj(arr) {
      let sortedArr = [];

      sortedArr = arr.sort((a, b) => {
        return b.calls - a.calls;
      });

      return sortedArr;
    },

    parseDateRange(date) {
      if (date.length === 8) {
        let year = ("0" + date).slice(1, -4);
        let month = ("0" + date).slice(-4, -2);
        let day = ("0" + date).slice(-2);
        let fullDay = "";
        fullDay = day + "/" + month + "/" + year;
        return String(fullDay);
      } else if (date.length === 6) {
        let year = ("0" + date).slice(1, 5);
        let month = ("0" + date).slice(-2);
        let fullDay = "";
        fullDay = month + "/" + year;
        return String(fullDay);
      } else if (date.length === 17) {
        let fullDay = date.split("-");
        let firstYear = ("0" + fullDay[0]).slice(1, 5);
        let firstMonth = ("0" + fullDay[0]).slice(-4, -2);
        let firstDay = ("0" + fullDay[0]).slice(-2);

        let firstFullDay = "";
        firstFullDay = firstDay + "/" + firstMonth + "/" + firstYear;

        let lastYear = ("0" + fullDay[1]).slice(1, 5);
        let lastMonth = ("0" + fullDay[1]).slice(-4, -2);
        let lastDay = ("0" + fullDay[1]).slice(-2);

        let lastFullDay = "";
        lastFullDay = lastDay + "/" + lastMonth + "/" + lastYear;
        let finalDay = "";
        finalDay = firstFullDay + " - " + lastFullDay;
        return String(finalDay);
      } else {
        return date;
      }
    },
    currentMonthAndYearForPbx() {
      if (!this.period) {
        let options = { month: "short" };
        let month = String("0" + (new Date().getMonth() + 1)).slice(-2);
        let formattedMonth = new Intl.DateTimeFormat("fr-FR", options)
          .format(month)
          .slice(0, -2);
        this.textMonth = formattedMonth;
        let year = new Date().getFullYear();
        this.period = String(year) + String(month);
      }
    },
    initializeFiltersFromUrl() {
      const query = this.$route.query;

      Object.assign(this.filters, {
        start_date: query.start_date || this.filters.start_date,
        end_date: query.end_date || this.filters.end_date,
        destination_dn: query.destination_dn || this.filters.destination_dn,
        origin_dn: query.origin_dn || this.filters.origin_dn,
        caller_number: query.caller_number || this.filters.caller_number,
        did_number: query.did_number || this.filters.did_number,
        destination_dn_type:
          query.destination_dn_type || this.filters.destination_dn_type,
        origin_dn_type: query.origin_dn_type || this.filters.origin_dn_type,
        call_way: query.call_way || this.filters.call_way,
        call_status: query.call_status || this.filters.call_status,
        start_time: query.start_time || this.pbxTimeSelected[0], // Fallback to '00:00' default
        end_time: query.end_time || this.pbxTimeSelected[1], // Fallback to '23:59' default
      });

      // const startDateString = this.filters.start_date;
      // const endDateString = this.filters.end_date;

      // const dateObject = {
      //   start: new Date(startDateString).toISOString(),
      //   end: new Date(endDateString).toISOString(),
      // };

      // this.$store.dispatch("pbxCustomDate", dateObject);

      this.pagination.current_page =
        parseInt(query.page) || this.pagination.current_page;
      this.pagination.per_page =
        parseInt(query.per_page) || this.pagination.per_page;

      if (this.filters.destination_dn) {
        this.selectedDestinationDns = this.filters.destination_dn
          .split(",")
          .filter(Boolean);
      } else {
        this.selectedDestinationDns = [];
      }

      if (this.filters.caller_number) {
        this.selectedCallerNumbers = this.filters.caller_number
          .split(",")
          .filter(Boolean);
      } else {
        this.selectedCallerNumbers = [];
      }

      if (this.filters.origin_dn) {
        this.selectedOriginDns = this.filters.origin_dn.split(",");
      }
      if (this.filters.did_number) {
        this.selectedDidNumbers = this.filters.did_number.split(",");
      }

      if (
        this.filters.destination_dn ||
        this.filters.origin_dn ||
        this.filters.did_number
      ) {
        this.selectedElement = "filtered";
      }

      if (this.filters.destination_dn) {
        this.selectedElement = this.filters.destination_dn;
        this.selectedQueue = this.filters.destination_dn; // Assuming this is a queue detail view
      }

      this.getCallerNumbers();

      this.initialized = true;
    },
    formatFilterName(key) {
      const map = {
        origin_dn: "Origine DN",
        destination_dn: "Destination DN",
        did_number: "Numéro SDA",
        caller_number: "Numéro appelant",
        origin_dn_type: "Type Origine",
        destination_dn_type: "Type Destination",
        call_way: "Direction d'Appel",
        call_status: "Statut",
      };
      return map[key] || key;
    },
    removeFilter(key) {
      this.filters[key] = "";
      if (key === "call_status") {
        this.filters[key] = "all";
      }
      if (key === "origin_dn") {
        this.selectedOriginDns = [];
        this.filters.origin_dn_type = "";
      }
      if (key === "destination_dn") {
        this.selectedDestinationDns = [];
        this.filters.destination_dn_type = "";
      }
      if (key === "did_number") {
        this.selectedDidNumbers = [];
      }
      this.applyFilters();
    },
    elementRemovedDestination(element) {
      let splitedElement = element.includes("-") ? element.split("-") : element;
      let elementValue = element.includes("-") ? splitedElement[0] : element;
      elementValue = elementValue.replace(/^\*/, "0").replace(/[^0-9]/g, "");
      if (this.selectedDestinationDns.indexOf(elementValue) >= 0) {
        this.selectedDestinationDns.splice(
          this.selectedDestinationDns.indexOf(elementValue),
          1,
        );
      }
    },
    elementRemovedOrigin(element) {
      let splitedElement = element.includes("-") ? element.split("-") : element;
      let elementValue = element.includes("-") ? splitedElement[0] : element;
      elementValue = elementValue.replace(/^\*/, "0").replace(/[^0-9]/g, "");
      if (this.selectedOriginDns.indexOf(elementValue) >= 0) {
        this.selectedOriginDns.splice(
          this.selectedOriginDns.indexOf(elementValue),
          1,
        );
      }
    },
    elementRemovedDid(element) {
      let splitedElement = element.includes("-") ? element.split("-") : element;
      let elementValue = element.includes("-") ? splitedElement[0] : element;
      elementValue = elementValue.replace(/^\*/, "0").replace(/[^0-9]/g, "");
      if (this.selectedDidNumbers.indexOf(element) >= 0) {
        this.selectedDidNumbers.splice(
          this.selectedDidNumbers.indexOf(element),
          1,
        );
      }
    },
  },
  watch: {
    selectedtime: function (val) {
      this.filters.start_time = val[0];
      this.filters.end_time = val[1];
    },
    // period: function (val) {
    //  this.getCallerNumbers(val);
    //  if (this.selectedElement) {
    //   this.getCallerNumber(this.selectedElement);
    //  }
    // },
  },
  mounted() {
    // if (
    //   localStorage.getItem("cdr_tutorial") == 1 &&
    //   this.$cookie.getCookie("API").includes("0585")
    // ) {
    //   this.$refs.cdr_tutorial.show();
    // }
    // this.currentMonthAndYearForPbx();
    // this.getButtonSelectedFromQueryPeriod();
    this.$store.dispatch("pbxElements", null);
    this.$store.dispatch("groupSelected", false);
    this.$store.dispatch("groupSelectedName", []);
    // this.getCallerNumbers();
    this.concatArray().then(() => {
      this.initializeFiltersFromUrl();
    });
  },
  computed: {
    ...mapGetters([
      "hostNames",
      "hostName",
      "user",
      "pbx3cxCustomerCode",
      "pbx3cxTableConfig",
      "pbx3cxAgentConfig",
      "pbxMap",
      "pbxElements",
      "groupSelected",
      "groupSelectedName",
      "pbxTimeSelected",
    ]),
    activeFilters() {
      const ignoreKeys = [
        "start_date",
        "end_date",
        "start_time",
        "end_time",
        "destination_dn_type",
        "origin_dn_type",
        "origin_dn",
        "destination_dn",
        "did_number",
      ];

      return Object.entries(this.filters)
        .filter(([key, value]) => {
          if (ignoreKeys.includes(key)) return false;
          return value !== "" && value !== null && value !== "all";
        })
        .map(([key, value]) => {
          const displayValue =
            key === "call_way" || key === "call_status"
              ? this.$t(value)
              : value;

          return {
            key,
            label: this.formatFilterName(key),
            value: displayValue,
          };
        });
    },
  },
};
</script>

<style></style>
